


















































































































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  EbtoResponse,
  CampaignDecision,
  EbtoUserFinalizeRequest,
  EbtoCampaign
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import moment from "moment";
import HsabLoginWrapper from "@/shared/components/ui/HsabLoginWrapper.vue";
import TransferStepsWidget from "@/employee/components/ebto/TransferStepsWidget.vue";
import {
  EbtoRetained,
  EbtoTransferProcess
} from "@/employee/route-names";
import { useEbtoStore } from "@/shared/store/ebto";

@Component({
  components: {
    HsabLoginWrapper,
    TransferStepsWidget
  }
})
export default class PricingOffer extends Vue {

  ebtoStore = useEbtoStore();

  moment = moment;
  formatCurrency = formatCurrency;
  showPricingOfferCard = false;
  isSubmitting = false;

  mounted () {
    this.showPricingOfferCard = true;
    if (!this.hasPricingOffer && !this.ebtoStore.isFeeWaived) {
      this.showPricingOfferCard = false;
    }
  }

  get isSubmitDisabled () {
    return this.isSubmitting === true;
  }

  get showZeroAdminFeesCard (): boolean {
    return this.ebtoStore.isFeeWaived === true && !this.hasPricingOffer;
  }

  get hasPricingOffer (): boolean {
    return this.ebtoStore.incentiveAmount > 0;
  }

  progressNewOffer (): void {
    this.showPricingOfferCard = false;
  }

  sendToTransferProcess (): void {
    this.$router.push({ name: EbtoTransferProcess });
  }

  claimStayOffer (): void {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.ebtoStore.finalizeEbtoStayOffer({
      decision: CampaignDecision.Stay,
      userId: this.ebtoStore.verifiedUser.userId,
      eSignName: ""
    }).then(() => {
      this.isSubmitting = false;
      if (this.ebtoStore.isUserFlowComplete) {
        this.$router.push({ name: EbtoRetained });
      }
    });
  }
}


